export default {
  main: '#183859',
  secondary: '#DFC5AB',
  contrastingColor: '#ffffff',
  priceColor: '#183859',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#ffffff',
};
